export function customersNormalizeContacts({ contacts }) {
  return contacts?.map((contact) => ({
    ...contact,
    pickup_holder: contact?.pickup_holder ? 1 : 0,
    holder_id: contact.is_restricted_by_holder ? contact?.holder_id : undefined,
  }));
}
